import React from "react";
import companyCheckboxIcon from "../../assets/yfs_label/product_yfs_label/icons/company-checkbox.svg";
import supplierCheckboxIcon from "../../assets/yfs_label/product_yfs_label/icons/supplier-checkbox.svg";
import internalCheckboxIcon from "../../assets/yfs_label/product_yfs_label/icons/internal-checkbox.svg";
import publicCheckboxIcon from "../../assets/yfs_label/product_yfs_label/icons/public-checkbox.svg";

const CustomStatusCheckboxView = ({ itemKey, categories, checked }) => {
  const getCategoryValue = () => {
    if (itemKey.startsWith("certificates_")) {
      const certName = itemKey.replace("certificates_", "");
      return categories.certificates?.[certName];
    }

    if (itemKey.startsWith("variation_categories_")) {
      const path = itemKey.replace("variation_categories_", "");
      return categories.variation_categories?.[path];
    }

    return categories[itemKey];
  };

  const getIcon = (category) => {
    if (checked && category === null) {
      return publicCheckboxIcon;
    }
    switch (category) {
      case "Third party verified":
        return companyCheckboxIcon;
      case "Supplier information":
        return supplierCheckboxIcon;
      case "Company information":
        return internalCheckboxIcon;
      default:
        return null;
    }
  };

  const selectedCategory = getCategoryValue();
  const iconSrc = getIcon(selectedCategory);

  if (!iconSrc) {
    return null;
  }

  return (
    <div className="status-checkbox-container">
      <div className="status-indicator">
        <img
          src={iconSrc}
          alt={selectedCategory || "Initial status"}
          width={25}
          height={25}
          className="cursor-default"
        />
      </div>
    </div>
  );
};

export default CustomStatusCheckboxView;
